import { render, staticRenderFns } from "./ModalVinculoManualRecebimentosAr.vue?vue&type=template&id=22f379fb&lang=pug"
import script from "./ModalVinculoManualRecebimentosAr.vue?vue&type=script&lang=js"
export * from "./ModalVinculoManualRecebimentosAr.vue?vue&type=script&lang=js"
import style0 from "./ModalVinculoManualRecebimentosAr.vue?vue&type=style&index=0&id=22f379fb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports